import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { AccountTypeEnumProvider, bankAccount, BankAccountManipulationViewModel } from "./bankAccountManipulation-viewModel"

export class BankAccountManipulationView extends View<BankAccountManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-77E385DF-DD68-4F1D-8D09-7AD8837DD83E"
    }
    loadHtml(): string {
        let element = require('./bankAccountManipulation.html').default;
        let style = require('./bankAccountManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set bankAccount(v: ObservableArray<bankAccount>) { this._bankAccount = v; } public get bankAccount(): ObservableArray<bankAccount> { return this._bankAccount;} private _bankAccount: ObservableArray<bankAccount>;
    public set accountTypeEnumProvider(v: AccountTypeEnumProvider) { this._accountTypeEnumProvider = v; } public get accountTypeEnumProvider(): AccountTypeEnumProvider { return this._accountTypeEnumProvider;} private _accountTypeEnumProvider: AccountTypeEnumProvider;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestBankAccountCreation(){
        this.dataContext.requestBankAccountCreation();
    }
}
